import { useCallback, useState } from 'react';
import { Dialogs, Flex, Text } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import I18N from '@leverege/i18n';
import DeviceInput from '../../pairing/DeviceInput';
import SalesFlowTagSearch from './SalesFlowTagSearch';
import Loading from '../../../components/Loading';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const {
  t
} = I18N.ns('recovr.sale.tagSale');
export default function RecovrTagsInformation(props) {
  const {
    saleData,
    actions,
    qtyOfTags,
    knowTags,
    onChange: pOnChange,
    keys,
    location,
    tagBlueprint,
    error
  } = props;
  const [loading, setLoading] = useState(false);
  const [tagIds, setTagsIds] = useState(() => {
    const tags = {};
    for (let i = 1; i <= qtyOfTags; i++) {
      tags[`Tag ${i}`] = '';
    }
    return tags;
  });
  const createKey = async tagSerialNumber => {
    return GlobalState.dispatch(actions.child('keys').create({
      data: {
        notes: tagSerialNumber,
        displayName: `Key-${tagSerialNumber}`
      }
    }));
  };
  const onChange = useCallback(async evt => {
    setLoading(true);
    setTagsIds(prevState => ({
      ...prevState,
      [evt.value.tagNumber]: evt.value.tagId
    }));
    if (typeof evt.data === 'string') {
      pOnChange({
        data: 'keys',
        value: {
          ...saleData,
          [evt.data]: evt.value
        }
      });
    } else {
      const isTagPaired = Object.keys(keys).filter(key => keys[key]?.tagId?.toLowerCase() === evt.value.tagId.toLowerCase());
      let key, keyId;
      if (isTagPaired.length === 0) {
        key = await createKey(evt.value.tagSerial);
        keyId = key.id;
      } else {
        keyId = isTagPaired[0];
        key = keys[keyId]?.key;
      }
      pOnChange({
        data: 'keys',
        value: {
          ...keys,
          [keyId]: {
            key,
            ...evt.value
          }
        }
      });
    }
    setLoading(false);
  }, [pOnChange, saleData]);
  const openSearch = useCallback(evt => {
    Dialogs.show({
      id: 'salesFlowTagSearch',
      component: SalesFlowTagSearch,
      props: {
        actions,
        tagBlueprint,
        location,
        eventData: evt?.data?.field,
        value: '',
        onChange,
        knowTags
      }
    });
  }, [actions, location, tagBlueprint, onChange]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      variant: "bodyBold",
      children: t('title')
    }), /*#__PURE__*/_jsxs(Flex, {
      variant: "rowL",
      align: "center",
      children: [/*#__PURE__*/_jsx("img", {
        alt: "RecovR",
        width: 80,
        height: 80,
        src: "https://storage.googleapis.com/recovr-ui-assets/recovr-tag.png"
      }), /*#__PURE__*/_jsxs(Flex, {
        variant: "colM",
        children: [/*#__PURE__*/_jsxs(Text, {
          variant: "bodySmallBold",
          children: [qtyOfTags, " ", t('subTitle')]
        }), /*#__PURE__*/_jsxs(Text, {
          variant: "bodySmall",
          children: [t('enterTagText'), " "]
        })]
      })]
    }), tagIds && Object.entries(tagIds).map(([key, value]) => {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(Flex, {
          variant: "colM",
          children: [key, " *", /*#__PURE__*/_jsx(DeviceInput, {
            "data-test-postfix": "SalesFlowTag",
            eventData: key,
            onClick: openSearch,
            onFocus: openSearch,
            onChange: onChange,
            value: value
          })]
        }), error && !value && /*#__PURE__*/_jsx(Text, {
          variant: "inputCaptionSmallError",
          children: t('mandatoryTagText')
        })]
      });
    }), /*#__PURE__*/_jsx(Loading, {
      loading: loading
    })]
  });
}